import { useState } from "react";
import { cycle_active, rangeYears, Result_line } from "../../../../utils/MembresiaUtils";
import Input from "../../../components/custom/forms/Input";
import { GetApi } from "../../../../helpers/RestApi";

const Card = ({ data, grafic, onClick }) => {
  const {
    code,
    created_at,
    updated_at,
    descont,
    description,
    fecha_limite,
    id,
    limit,
    limit_cash,
    name,
    region,
    status_id,
    terminos,
    suscriptos,
    cycle
  } = data;

  const ciclos = [
    { id: 1, mes: "Enero" },
    { id: 2, mes: "Febrero" },
    { id: 3, mes: "Marzo" },
    { id: 4, mes: "Abril" },
    { id: 5, mes: "Mayo" },
    { id: 6, mes: "Junio" },
    { id: 7, mes: "Julio" },
    { id: 8, mes: "Agosto" },
    { id: 9, mes: "Septiembre" },
    { id: 10, mes: "Octubre" },
    { id: 11, mes: "Noviembre" },
    { id: 12, mes: "Diciembre" },
  ];

  const años = rangeYears();

  const [suscriptor, setSuscriptor] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [selectedMonthYear, setSelectedMonthYear] = useState("");

  // Calcular uso acumulado
  const acumulado = grafic && grafic.length > 0
    ? Result_line(grafic).acumulado[Result_line(grafic).acumulado.length - 1]
    : 0;

  const entradasUsadas = grafic && grafic.length > 0
    ? grafic.reduce((acc, item) => acc + (item.entradas_usadas || 0), 0)
    : 0;

  const porcentajeGasto = limit_cash > 0 ? (acumulado / limit_cash) * 100 : 0;
  const porcentajeEntradas = limit > 0 ? (entradasUsadas / limit) * 100 : 0;

  const onChange = async (e) => {
    switch (e.target.name) {
      case "suscriptor": {
        if (e.target.value.length > 3) {
          let params = {
            ['email[0]']: e.target.value,
            membresia_id: id
          };

          const response = await GetApi({
            url: "/membresias/verify",
            params: params,
            setLoading: setLoading
          });

          setSuscriptor(response.data);
        } else {
          setSuscriptor(null);
        }
      } break;
    }
  };

  return (
    <div className="col-12 mb-3">
      <div className="card border-0 shadow-sm" style={{ borderRadius: "12px", overflow: "hidden" }}>
        {/* Header con acciones */}
        <div className="card-header bg-white border-0 py-3">
          <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center gap-3">
            <div className="d-flex flex-wrap align-items-center gap-2">
              <h6 className="mb-0 fw-bold">{name}</h6>
              <span className="badge bg-secondary rounded-pill" style={{ fontSize: "0.65rem" }}>
                {cycle_active(cycle)} {data.year}
              </span>
              <span className={`badge rounded-pill ${status_id === 1 ? 'bg-success' : 'bg-danger'}`} style={{ fontSize: "0.65rem" }}>
                {status_id === 1 ? 'Activa' : 'Inactiva'}
              </span>
            </div>

            <div className="d-flex flex-wrap gap-1 w-100 w-lg-auto">
              {/* Dropdown Año */}
              <div className="dropdown">
                <button
                  className="btn btn-sm btn-outline-secondary rounded-pill px-2 px-md-3 dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{ fontSize: "0.75rem" }}
                >
                  <span className="d-none d-sm-inline">{data.year}</span>
                  <span className="d-inline d-sm-none">{data.year}</span>
                </button>
                <ul className="dropdown-menu">
                  {años.map((c) => {
                    if (c === data.year) return null;
                    return (
                      <li key={c}>
                        <button
                          className="dropdown-item"
                          onClick={(event) => onClick(event, { id: id, year: c })}
                          name="year"
                        >
                          {c} <i className="bi bi-check-all"></i>
                        </button>
                      </li>
                    );
                  })}
                </ul>
              </div>

              {/* Dropdown Ciclo */}
              <div className="dropdown">
                <button
                  className="btn btn-sm btn-outline-secondary rounded-pill px-2 px-md-3 dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{ fontSize: "0.75rem" }}
                >
                  <span className="d-none d-md-inline">{cycle_active(cycle)}</span>
                  <span className="d-inline d-md-none">{cycle_active(cycle).substring(0, 3)}</span>
                </button>
                <ul className="dropdown-menu">
                  {ciclos.map((c) => {
                    if (c.id === cycle) return null;
                    return (
                      <li key={c.id}>
                        <button
                          className="dropdown-item"
                          onClick={(event) => onClick(event, { id: id, ciclo: c.id })}
                          name="ciclo"
                        >
                          {c.mes} <i className="bi bi-check-all"></i>
                        </button>
                      </li>
                    );
                  })}
                </ul>
              </div>

              {/* Botones de acción */}
              <button
                className="btn btn-sm btn-primary rounded-pill px-3"
                onClick={(event) => onClick(event, data)}
                name="usuarios"
                style={{ fontSize: "0.75rem", cursor: "pointer" }}
                type="button"
              >
                <i className="bi bi-person-arms-up"></i>
                <span className="d-none d-md-inline ms-1">Usuarios</span>
              </button>

              <button
                className="btn btn-sm btn-warning rounded-pill px-3"
                onClick={(event) => onClick(event, data)}
                name="editar"
                style={{ fontSize: "0.75rem", cursor: "pointer" }}
                type="button"
              >
                <i className="bi bi-pencil"></i>
                <span className="d-none d-md-inline ms-1">Editar</span>
              </button>

              {/* Dropdown Estado */}
              <div className="dropdown">
                <button
                  className="btn btn-sm btn-outline-dark rounded-pill px-2 px-md-3 dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{ fontSize: "0.75rem" }}
                >
                  <span className="d-none d-md-inline">Estado</span>
                  <i className="bi bi-gear d-inline d-md-none"></i>
                </button>
                <ul className="dropdown-menu">
                  {status_id !== 1 && (
                    <li>
                      <button
                        className="dropdown-item text-success"
                        onClick={(event) => onClick(event, { id: id, status: 1 })}
                        name="status"
                      >
                        Activar <i className="bi bi-check-all"></i>
                      </button>
                    </li>
                  )}
                  {status_id !== 2 && (
                    <li>
                      <button
                        className="dropdown-item text-danger"
                        onClick={(event) => onClick(event, { id: id, status: 2 })}
                        name="status"
                      >
                        Desactivar <i className="bi bi-trash"></i>
                      </button>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Cuerpo de la card */}
        <div className="card-body">
          <div className="row g-3">
            {/* Columna izquierda - Info básica */}
            <div className="col-12 col-lg-4">
              <div className="d-flex flex-column gap-2">
                <div className="d-flex justify-content-between align-items-center p-2 bg-light rounded">
                  <span className="text-muted" style={{ fontSize: "0.75rem" }}>Código:</span>
                  <span className="fw-bold" style={{ fontSize: "0.8rem" }}>{code}</span>
                </div>

                <div className="d-flex justify-content-between align-items-center p-2 bg-light rounded">
                  <span className="text-muted" style={{ fontSize: "0.75rem" }}>Región:</span>
                  <span className="fw-bold" style={{ fontSize: "0.8rem" }}>{region}</span>
                </div>

                <div className="d-flex justify-content-between align-items-center p-2 bg-light rounded">
                  <span className="text-muted" style={{ fontSize: "0.75rem" }}>Ciclo Activo:</span>
                  <span className="fw-bold" style={{ fontSize: "0.8rem" }}>{cycle_active(cycle)}</span>
                </div>

                <div className="d-flex justify-content-between align-items-center p-2 bg-light rounded">
                  <span className="text-muted" style={{ fontSize: "0.75rem" }}>Usuarios Activos:</span>
                  <span className="badge bg-primary rounded-pill" style={{ fontSize: "0.7rem" }}>{suscriptos || 0}</span>
                </div>

                {descont && (
                  <div className="d-flex justify-content-between align-items-center p-2 bg-light rounded">
                    <span className="text-muted" style={{ fontSize: "0.75rem" }}>Descuento:</span>
                    <span className="fw-bold text-success" style={{ fontSize: "0.8rem" }}>{descont}%</span>
                  </div>
                )}

                {description && (
                  <div className="p-2 bg-light rounded">
                    <span className="text-muted d-block mb-1" style={{ fontSize: "0.75rem" }}>Descripción:</span>
                    <small className="text-secondary" style={{ fontSize: "0.7rem" }}>{description}</small>
                  </div>
                )}

                {/* Selector de mes-año para reportes */}
                <div className="p-2 bg-light rounded">
                  <label className="text-muted d-block mb-2" style={{ fontSize: "0.75rem" }}>
                    Filtro de Reportes (Mes/Año):
                  </label>
                  <div className="d-flex gap-2">
                    <input
                      type="month"
                      className="form-control form-control-sm flex-grow-1"
                      value={selectedMonthYear}
                      onChange={(e) => setSelectedMonthYear(e.target.value)}
                      style={{ fontSize: "0.75rem" }}
                    />
                    <button
                      className="btn btn-sm btn-primary rounded-pill px-3"
                      onClick={(event) => {
                        const dataWithFilter = {
                          ...data,
                          customMonthYear: selectedMonthYear || null
                        };
                        console.log('Enviando datos al modal:', dataWithFilter);
                        console.log('Mes seleccionado:', selectedMonthYear);
                        onClick(event, dataWithFilter);
                      }}
                      name="reportes"
                      type="button"
                      style={{ fontSize: "0.75rem", whiteSpace: "nowrap", cursor: "pointer" }}
                    >
                      <i className="bi bi-ticket"></i>
                      <span className="ms-1">Ver</span>
                    </button>
                  </div>
                  {selectedMonthYear && (
                    <small className="text-info d-block mt-1" style={{ fontSize: "0.65rem" }}>
                      <i className="bi bi-info-circle"></i> Los reportes se filtrarán por este mes
                    </small>
                  )}
                </div>

                {/* Buscador de usuarios */}
                <div className="mt-2">
                  <button
                    className="btn btn-sm btn-outline-primary w-100 rounded-pill"
                    onClick={() => setShowSearch(!showSearch)}
                    type="button"
                    style={{ cursor: "pointer" }}
                  >
                    <i className="bi bi-search"></i> {showSearch ? 'Ocultar búsqueda' : 'Buscar usuario'}
                  </button>

                  {showSearch && (
                    <div className="mt-2">
                      <Input
                        onChange={onChange}
                        label=""
                        placeholder="Ingresa email del usuario..."
                        name="suscriptor"
                        type="text"
                        validate={{ msg: "", status: false }}
                        disabled={false}
                      />
                      {suscriptor && (
                        <div className="mt-2 p-2 border rounded">
                          <div className={`d-flex align-items-center gap-2 ${suscriptor[0].status ? 'text-success' : 'text-danger'}`}>
                            <i className={`bi ${suscriptor[0].status ? 'bi-check-circle-fill' : 'bi-x-circle-fill'}`}></i>
                            <small>{suscriptor[0].verificado}</small>
                          </div>
                          <button
                            className={`btn btn-sm w-100 mt-2 ${suscriptor[0].status ? 'btn-danger' : 'btn-success'}`}
                            onClick={(event) => onClick(event, {...suscriptor[0], id: id})}
                            name={suscriptor[0].status ? "quitar-membresia" : "añadir-membresia"}
                            type="button"
                            style={{ cursor: "pointer" }}
                          >
                            {suscriptor[0].status ? 'Quitar de membresía' : 'Agregar a membresía'}
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Columna derecha - Barra de progreso */}
            <div className="col-12 col-lg-8">
              <div className="d-flex flex-column gap-3">
                {/* Barra de uso de dinero */}
                <div>
                  <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mb-2 gap-2">
                    <span className="fw-bold" style={{ fontSize: "0.8rem" }}>Uso de Presupuesto</span>
                    <span className="badge bg-info rounded-pill" style={{ fontSize: "0.7rem" }}>
                      ${acumulado.toLocaleString()} / ${parseFloat(limit_cash).toLocaleString()}
                    </span>
                  </div>
                  <div className="progress" style={{ height: "30px", borderRadius: "8px" }}>
                    <div
                      className={`progress-bar ${porcentajeGasto >= 90 ? 'bg-danger' : porcentajeGasto >= 70 ? 'bg-warning' : 'bg-success'}`}
                      role="progressbar"
                      style={{ width: `${Math.min(porcentajeGasto, 100)}%` }}
                      aria-valuenow={porcentajeGasto}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      <span className="fw-bold" style={{ fontSize: "0.85rem" }}>{porcentajeGasto.toFixed(1)}%</span>
                    </div>
                  </div>
                  <small className="text-muted d-block mt-1" style={{ fontSize: "0.7rem" }}>
                    Disponible: ${(parseFloat(limit_cash) - acumulado).toLocaleString()}
                  </small>
                </div>

                {/* Estadísticas rápidas */}
                <div className="row g-2 mt-2">
                  <div className="col-6 col-sm-3">
                    <div className="text-center p-2 bg-light rounded">
                      <div className="text-muted mb-1" style={{ fontSize: "0.65rem" }}>Límite Entradas</div>
                      <div className="fw-bold" style={{ fontSize: "0.9rem" }}>{limit}</div>
                    </div>
                  </div>
                  <div className="col-6 col-sm-3">
                    <div className="text-center p-2 bg-light rounded">
                      <div className="text-muted mb-1" style={{ fontSize: "0.65rem" }}>Compras</div>
                      <div className="fw-bold" style={{ fontSize: "0.9rem" }}>{grafic ? grafic.length : 0}</div>
                    </div>
                  </div>
                  <div className="col-6 col-sm-3">
                    <div className="text-center p-2 bg-light rounded">
                      <div className="text-muted mb-1" style={{ fontSize: "0.65rem" }}>Promedio/compra</div>
                      <div className="fw-bold" style={{ fontSize: "0.9rem" }}>${grafic && grafic.length > 0 ? (acumulado / grafic.length).toFixed(0) : 0}</div>
                    </div>
                  </div>
                  <div className="col-6 col-sm-3">
                    <div className="text-center p-2 bg-light rounded">
                      <div className="text-muted mb-1" style={{ fontSize: "0.65rem" }}>Estado</div>
                      <div className={`fw-bold ${porcentajeGasto < 70 ? 'text-success' : porcentajeGasto < 90 ? 'text-warning' : 'text-danger'}`} style={{ fontSize: "0.9rem" }}>
                        {porcentajeGasto < 70 ? 'Óptimo' : porcentajeGasto < 90 ? 'Moderado' : 'Crítico'}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
